import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Heap } from '@datacamp/exercise-tracking';
import uuidv4 from 'uuid/v4';
const trackHeapEvent = (action, sessionId, value) => Heap.trackEvent({
  heapEventProperties: {
    // @ts-expect-error this is not a valid event_category but is still allowed by Heap https://datacamp.atlassian.net/wiki/spaces/PRODENG/pages/2173796462/Heap+Event+properties#Event-categories
    event_category: 'vm',
    sessionId,
    value
  },
  name: action
});
export class UserEventTracker {
  // @ts-expect-error this property will be removed in an upcoming refactor
  constructor(userId) {
    this.userId = userId;
  }
  eventUserFirstMouseClick(sessionId) {
    trackHeapEvent('Learn - RemoteDesktopExercise - User First Mouse Click', sessionId);
  }
  eventUserRequestSessionFrontend() {
    trackHeapEvent('Learn - RemoteDesktopExercise - User Request Session Frontend');
  }
  eventUserResponseSessionFrontend(sessionId) {
    trackHeapEvent('Learn - RemoteDesktopExercise - User Response Session Frontend', sessionId);
  }
  eventUserResponseSessionFrontendError(errorType) {
    trackHeapEvent('Learn - RemoteDesktopExercise - User Response Session Frontend Error', undefined, errorType);
  }
}
_defineProperty(UserEventTracker, "trackingUuid", uuidv4());